// src/styles/constants.ts
var cssVars = {
  docHeight: "--doc-height"
};
var headerHeightPx = 102;
var smHeaderHeightPx = 60;
var smHeaderLogoMarginLeft = "30px";
var navBorderRadiusPx = 12;

export {
  cssVars,
  headerHeightPx,
  smHeaderHeightPx,
  smHeaderLogoMarginLeft,
  navBorderRadiusPx
};
